import utils from 'utils';
import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

/**
 * @name retrieveReservation
 * @desc Dispatcher for the GMA request that retrieves a reservation.
 * @param {Object} reservationData - Reservation data to be used as params
 * @param {string} reservation.firstName - Renter's first name
 * @param {string} reservation.lastName - Renter's last name
 * @param {string} reservation.confirmationNumber - Reservation confirmation number
 * @param {string} reservation.customPathCheckInBrandCode - Partner Brand Code
 * @param {string} reservation.customPathCheckInBrandName - Partner Brand Name
 * @param {string} reservation.customPathCheckInCheckInLogo - Partner Brand path for logo
 * @param {strin} reservation.customPathCheckInLandingPage - Custom Path Check In Lookup relative path
 * @param {string} reservation.customPathCheckInFaqCaasTag - Faq Caas Tag path
 * @param {string} reservation.customPathCheckInCustomerSupportCaasTag - Customer Support Caas Tag path
 * @param {boolean} redirect - Option that toggles whether GMA's go_to response should be processed (default: true)
 * @returns {Function}
 */
export const retrieveReservation =
  (reservationData, redirect = true, isFromCustomPathLP = false) =>
  (dispatch) => {
    const isCutomPathEnabled = utils.config.getIsCustomPathEnabled();
    return dispatch(
      gmiRequest({
        action: actions.request({
          data: {
            params: {
              ...reservationData,
              enableCustomPathCheckIn: isFromCustomPathLP ? true : !!isCutomPathEnabled,
            },
          },
          service: services.gma.reservations.retrieve,
        }),
        loadingOverlay: true,
        redirect,
      })
    );
  };
